import { isPlainLinkActivation, type LinkActivation } from "../router";
import type { NativeRuntime } from "./native";

export async function handleNativeLink(
  event: LinkActivation & { preventDefault(): void },
  runtime: NativeRuntime | null,
  action: (runtime: NativeRuntime) => Promise<unknown>,
): Promise<void> {
  if (runtime === null || !isPlainLinkActivation(event)) return;
  event.preventDefault();
  try {
    await action(runtime);
  } catch (error) {
    console.error("Native link action failed", error);
  }
}
